/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_StageInputs */

const en_task_settings_stage = /** @type {(inputs: Task_Settings_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage`)
};

const pt_br2_task_settings_stage = /** @type {(inputs: Task_Settings_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etapa`)
};

/**
* | output |
* | --- |
* | "Stage" |
*
* @param {Task_Settings_StageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_stage = /** @type {((inputs?: Task_Settings_StageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_StageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_stage(inputs)
	return pt_br2_task_settings_stage(inputs)
});